import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "field-hint" };
const _hoisted_2 = { class: "field-hint" };
const _hoisted_3 = {
    key: 0,
    class: "hint-error"
};
const _hoisted_4 = { key: 1 };
import { computed, ref } from 'vue';
import { Promotion, VideoPlay, VideoPause, Delete } from '@element-plus/icons-vue';
import { FUNCTION_CODE as FC, FUNCTION_CODES, getFunctionMeta } from '@/core/modbus/constants';
import { validateHex, hexToBytes } from '@/core/modbus/format';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RequestForm',
    props: {
        form: {},
        parsedValues: {},
        validationErrors: {},
        isValid: { type: Boolean },
        previewHex: {},
        connected: { type: Boolean },
        polling: { type: Boolean },
        framing: {}
    },
    emits: ["send", "toggle-poll", "send-raw"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const activeTab = ref('standard');
        const unitLabel = computed(() => (props.framing === 'rtu' ? '从站地址' : '单元标识'));
        const meta = computed(() => getFunctionMeta(props.form.functionCode));
        const isMultiWrite = computed(() => props.form.functionCode === FC.WRITE_MULTIPLE_COILS ||
            props.form.functionCode === FC.WRITE_MULTIPLE_REGISTERS);
        const rawPlaceholder = computed(() => props.form.rawMode === 'auto'
            ? '03 00 00 00 0A   ← 功能码开始，地址与校验自动补全'
            : props.framing === 'rtu'
                ? '01 03 00 00 00 0A C5 CD   ← 完整帧，含 CRC'
                : '00 01 00 00 00 06 01 03 00 00 00 0A   ← 完整帧，含 MBAP');
        const rawError = computed(() => {
            if (props.form.rawHex.trim() === '')
                return '';
            return validateHex(props.form.rawHex) ?? '';
        });
        const rawByteCount = computed(() => {
            if (rawError.value || props.form.rawHex.trim() === '')
                return 0;
            try {
                return hexToBytes(props.form.rawHex).length;
            }
            catch {
                return 0;
            }
        });
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_form_item = _resolveComponent("el-form-item");
            const _component_el_option = _resolveComponent("el-option");
            const _component_el_select = _resolveComponent("el-select");
            const _component_el_input_number = _resolveComponent("el-input-number");
            const _component_el_switch = _resolveComponent("el-switch");
            const _component_el_radio_button = _resolveComponent("el-radio-button");
            const _component_el_radio_group = _resolveComponent("el-radio-group");
            const _component_el_alert = _resolveComponent("el-alert");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_form = _resolveComponent("el-form");
            const _component_el_tab_pane = _resolveComponent("el-tab-pane");
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_tabs = _resolveComponent("el-tabs");
            const _component_el_card = _resolveComponent("el-card");
            return (_openBlock(), _createBlock(_component_el_card, { class: "mb-card" }, {
                header: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createElementVNode("div", { class: "card-header" }, [
                        _createElementVNode("span", { class: "card-title" }, "发送请求")
                    ], -1)
                ])),
                default: _withCtx(() => [
                    _createVNode(_component_el_tabs, {
                        modelValue: activeTab.value,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((activeTab).value = $event))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_el_tab_pane, {
                                label: "标准请求",
                                name: "standard"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_el_form, {
                                        "label-width": "88px",
                                        "label-position": "left",
                                        size: "default"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { label: unitLabel.value }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_el_input, {
                                                        modelValue: _ctx.form.unitId,
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.form.unitId) = $event)),
                                                        placeholder: "十六进制，如 01"
                                                    }, {
                                                        append: _withCtx(() => _cache[21] || (_cache[21] = [
                                                            _createTextVNode("HEX", -1)
                                                        ])),
                                                        _: 1
                                                    }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }, 8, ["label"]),
                                            _createVNode(_component_el_form_item, { label: "功能码" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_el_select, {
                                                        modelValue: _ctx.form.functionCode,
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.form.functionCode) = $event)),
                                                        style: { "width": "100%" }
                                                    }, {
                                                        default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FUNCTION_CODES), (fc) => {
                                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                                    key: fc.code,
                                                                    label: fc.label,
                                                                    value: fc.code
                                                                }, null, 8, ["label", "value"]));
                                                            }), 128))
                                                        ]),
                                                        _: 1
                                                    }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_el_form_item, { label: "起始地址" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_el_input, {
                                                        modelValue: _ctx.form.startAddress,
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.form.startAddress) = $event)),
                                                        placeholder: "起始地址"
                                                    }, {
                                                        append: _withCtx(() => [
                                                            _createVNode(_component_el_select, {
                                                                modelValue: _ctx.form.addressRadix,
                                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.form.addressRadix) = $event)),
                                                                style: { "width": "76px" }
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_el_option, {
                                                                        label: "HEX",
                                                                        value: "hex"
                                                                    }),
                                                                    _createVNode(_component_el_option, {
                                                                        label: "DEC",
                                                                        value: "dec"
                                                                    })
                                                                ]),
                                                                _: 1
                                                            }, 8, ["modelValue"])
                                                        ]),
                                                        _: 1
                                                    }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            (meta.value?.needQuantity && !meta.value?.isWrite)
                                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                    key: 0,
                                                    label: "数量"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_el_input_number, {
                                                            modelValue: _ctx.form.quantity,
                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.form.quantity) = $event)),
                                                            min: 1,
                                                            max: meta.value.maxQuantity,
                                                            style: { "width": "100%" },
                                                            "controls-position": "right"
                                                        }, null, 8, ["modelValue", "max"])
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true),
                                            (_ctx.form.functionCode === _unref(FC).WRITE_SINGLE_COIL)
                                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                    key: 1,
                                                    label: "线圈状态"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_el_switch, {
                                                            modelValue: _ctx.form.coilOn,
                                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.form.coilOn) = $event)),
                                                            "active-text": "ON (FF00)",
                                                            "inactive-text": "OFF (0000)",
                                                            "inline-prompt": "",
                                                            style: { "--el-switch-on-color": "#67c23a" }
                                                        }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true),
                                            (_ctx.form.functionCode === _unref(FC).WRITE_SINGLE_REGISTER)
                                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                    key: 2,
                                                    label: "写入值"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_el_input, {
                                                            modelValue: _ctx.form.singleValue,
                                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.form.singleValue) = $event)),
                                                            placeholder: "0 - 65535"
                                                        }, {
                                                            append: _withCtx(() => [
                                                                _createVNode(_component_el_select, {
                                                                    modelValue: _ctx.form.writeValueRadix,
                                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.form.writeValueRadix) = $event)),
                                                                    style: { "width": "76px" }
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_component_el_option, {
                                                                            label: "DEC",
                                                                            value: "dec"
                                                                        }),
                                                                        _createVNode(_component_el_option, {
                                                                            label: "HEX",
                                                                            value: "hex"
                                                                        })
                                                                    ]),
                                                                    _: 1
                                                                }, 8, ["modelValue"])
                                                            ]),
                                                            _: 1
                                                        }, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true),
                                            (isMultiWrite.value)
                                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                    key: 3,
                                                    label: "写入值"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_el_input, {
                                                            modelValue: _ctx.form.writeValues,
                                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.form.writeValues) = $event)),
                                                            type: "textarea",
                                                            rows: 3,
                                                            placeholder: _ctx.form.functionCode === _unref(FC).WRITE_MULTIPLE_COILS
                                                                ? '每个线圈填 0 或 1，用空格/逗号分隔，如：1 0 1 1'
                                                                : '每个寄存器一个值，用空格/逗号分隔，如：100 200 300'
                                                        }, null, 8, ["modelValue", "placeholder"]),
                                                        _createElementVNode("div", _hoisted_1, [
                                                            _createElementVNode("span", null, "已解析 " + _toDisplayString(_ctx.parsedValues.length) + " 个值", 1),
                                                            _createVNode(_component_el_radio_group, {
                                                                modelValue: _ctx.form.writeValueRadix,
                                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.form.writeValueRadix) = $event)),
                                                                size: "small"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_el_radio_button, { value: "dec" }, {
                                                                        default: _withCtx(() => _cache[22] || (_cache[22] = [
                                                                            _createTextVNode("DEC", -1)
                                                                        ])),
                                                                        _: 1,
                                                                        __: [22]
                                                                    }),
                                                                    _createVNode(_component_el_radio_button, { value: "hex" }, {
                                                                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                                                                            _createTextVNode("HEX", -1)
                                                                        ])),
                                                                        _: 1,
                                                                        __: [23]
                                                                    })
                                                                ]),
                                                                _: 1
                                                            }, 8, ["modelValue"])
                                                        ])
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true),
                                            _createVNode(_component_el_form_item, { label: "待发报文" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_el_input, {
                                                        "model-value": _ctx.previewHex,
                                                        readonly: "",
                                                        type: "textarea",
                                                        rows: 2,
                                                        class: "preview-input"
                                                    }, null, 8, ["model-value"])
                                                ]),
                                                _: 1
                                            }),
                                            (_ctx.validationErrors.length)
                                                ? (_openBlock(), _createBlock(_component_el_alert, {
                                                    key: 4,
                                                    type: "warning",
                                                    closable: false,
                                                    "show-icon": "",
                                                    class: "validate-alert"
                                                }, {
                                                    default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationErrors, (e, i) => {
                                                            return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(e), 1));
                                                        }), 128))
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true),
                                            _createVNode(_component_el_form_item, { label: "超时" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_el_input_number, {
                                                        modelValue: _ctx.form.timeoutMs,
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.form.timeoutMs) = $event)),
                                                        min: 50,
                                                        max: 20000,
                                                        step: 100,
                                                        "controls-position": "right",
                                                        style: { "width": "130px" }
                                                    }, null, 8, ["modelValue"]),
                                                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "unit-text" }, "ms", -1)),
                                                    _cache[25] || (_cache[25] = _createElementVNode("span", { class: "spacer" }, null, -1)),
                                                    _cache[26] || (_cache[26] = _createElementVNode("span", { class: "inline-label" }, "轮询周期", -1)),
                                                    _createVNode(_component_el_input_number, {
                                                        modelValue: _ctx.form.pollIntervalMs,
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.form.pollIntervalMs) = $event)),
                                                        min: 20,
                                                        max: 60000,
                                                        step: 100,
                                                        "controls-position": "right",
                                                        style: { "width": "130px" }
                                                    }, null, 8, ["modelValue"]),
                                                    _cache[27] || (_cache[27] = _createElementVNode("span", { class: "unit-text" }, "ms", -1))
                                                ]),
                                                _: 1,
                                                __: [24, 25, 26, 27]
                                            }),
                                            _createVNode(_component_el_form_item, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_el_button, {
                                                        type: "primary",
                                                        icon: _unref(Promotion),
                                                        disabled: !_ctx.connected || !_ctx.isValid || _ctx.polling,
                                                        onClick: _cache[12] || (_cache[12] = ($event) => (emit('send')))
                                                    }, {
                                                        default: _withCtx(() => _cache[28] || (_cache[28] = [
                                                            _createTextVNode(" 发送 ", -1)
                                                        ])),
                                                        _: 1,
                                                        __: [28]
                                                    }, 8, ["icon", "disabled"]),
                                                    _createVNode(_component_el_button, {
                                                        type: _ctx.polling ? 'danger' : 'success',
                                                        icon: _ctx.polling ? _unref(VideoPause) : _unref(VideoPlay),
                                                        disabled: !_ctx.connected || !_ctx.isValid,
                                                        onClick: _cache[13] || (_cache[13] = ($event) => (emit('toggle-poll')))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.polling ? '停止轮询' : '循环发送'), 1)
                                                        ]),
                                                        _: 1
                                                    }, 8, ["type", "icon", "disabled"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_el_tab_pane, {
                                label: "自定义报文",
                                name: "raw"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_el_form, {
                                        "label-width": "88px",
                                        "label-position": "left"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { label: "模式" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_el_radio_group, {
                                                        modelValue: _ctx.form.rawMode,
                                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.form.rawMode) = $event))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_el_tooltip, {
                                                                content: _ctx.framing === 'rtu'
                                                                    ? '只填 PDU（功能码开始），自动补从站地址与 CRC'
                                                                    : '只填 PDU（功能码开始），自动补 MBAP 头',
                                                                placement: "top"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_el_radio_button, { value: "auto" }, {
                                                                        default: _withCtx(() => _cache[29] || (_cache[29] = [
                                                                            _createTextVNode("自动补全", -1)
                                                                        ])),
                                                                        _: 1,
                                                                        __: [29]
                                                                    })
                                                                ]),
                                                                _: 1
                                                            }, 8, ["content"]),
                                                            _createVNode(_component_el_tooltip, {
                                                                content: "完整帧原样发出，不做任何加工",
                                                                placement: "top"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_el_radio_button, { value: "raw" }, {
                                                                        default: _withCtx(() => _cache[30] || (_cache[30] = [
                                                                            _createTextVNode("原样发送", -1)
                                                                        ])),
                                                                        _: 1,
                                                                        __: [30]
                                                                    })
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            (_ctx.form.rawMode === 'auto')
                                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                    key: 0,
                                                    label: unitLabel.value
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_el_input, {
                                                            modelValue: _ctx.form.unitId,
                                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.form.unitId) = $event)),
                                                            placeholder: "十六进制，如 01"
                                                        }, {
                                                            append: _withCtx(() => _cache[31] || (_cache[31] = [
                                                                _createTextVNode("HEX", -1)
                                                            ])),
                                                            _: 1
                                                        }, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                }, 8, ["label"]))
                                                : _createCommentVNode("", true),
                                            _createVNode(_component_el_form_item, { label: "报文" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_el_input, {
                                                        modelValue: _ctx.form.rawHex,
                                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.form.rawHex) = $event)),
                                                        type: "textarea",
                                                        rows: 4,
                                                        placeholder: rawPlaceholder.value,
                                                        class: "preview-input"
                                                    }, null, 8, ["modelValue", "placeholder"]),
                                                    _createElementVNode("div", _hoisted_2, [
                                                        (rawError.value)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(rawError.value), 1))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(rawByteCount.value) + " 字节", 1))
                                                    ])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_el_form_item, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_el_button, {
                                                        type: "primary",
                                                        icon: _unref(Promotion),
                                                        disabled: !_ctx.connected || !!rawError.value || rawByteCount.value === 0,
                                                        onClick: _cache[17] || (_cache[17] = ($event) => (emit('send-raw')))
                                                    }, {
                                                        default: _withCtx(() => _cache[32] || (_cache[32] = [
                                                            _createTextVNode(" 发送 ", -1)
                                                        ])),
                                                        _: 1,
                                                        __: [32]
                                                    }, 8, ["icon", "disabled"]),
                                                    _createVNode(_component_el_button, {
                                                        icon: _unref(Delete),
                                                        onClick: _cache[18] || (_cache[18] = ($event) => (_ctx.form.rawHex = ''))
                                                    }, {
                                                        default: _withCtx(() => _cache[33] || (_cache[33] = [
                                                            _createTextVNode("清空", -1)
                                                        ])),
                                                        _: 1,
                                                        __: [33]
                                                    }, 8, ["icon"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["modelValue"])
                ]),
                _: 1
            }));
        };
    }
});
